import { completeName, i18n } from "../../utils";

export const normalizeWarehousesList = (payload: any) => {
  const data = payload?.item?.items;
  return data ? data.map((item: any) => ({
    ...item,
    name: completeName(item.firstName, item.middleName, item.lastName),
    access: i18n(item.access),
  })) : [];
};
